import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowTrendDown,
  faFileInvoiceDollar,
  faMagnifyingGlass,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";

const stats = [
  {
    icon: faArrowTrendDown,
    value: "21%",
    label: "of Your Bottom Line Is Lost to Document Chaos",
  },
  {
    icon: faFileInvoiceDollar,
    value: "$20",
    label: "Per Document: The Hidden Cost of Manual Management",
  },
  {
    icon: faMagnifyingGlass,
    value: "40-60%",
    label: "of Small Businesses Never Recover After Document Loss",
  },
  {
    icon: faTriangleExclamation,
    value: "47%",
    label: "of Your Workforce Can't Find What They Need",
  },
];

const Section2 = ({ url }) => {
  const bgImage =
    "https://images.unsplash.com/photo-1563013544-824ae1b704d3?auto=format&fit=crop&w=1400&q=70";

  return (
    <section className="home-section-2">
    <div className="container overflow-hidden">
      <div className="section-2-header" data-aos="fade-up">
        <h2 className="section-title">
          Hidden Cost of <br />
          <span className="gradient-text">Uncontrolled Document Access</span>
        </h2>
      </div>

      <div className="stats-grid ">

        <div className="stat-card overflow-hidden" data-aos="fade-right" data-aos-delay="600">
          <div className="stat-icon-wrapper">
            <img src={`${url}images/concord/section-2/icon-loss.png`} alt="" className="stat-icon" />
          </div>
          <div className="stat-value gradient-text overflow-hidden">21%</div>
          <p className="stat-desc">of Your Bottom Line Is Lost to Document Chaos</p>
        </div>

        <div className="stat-card overflow-hidden" data-aos="zoom-in" data-aos-delay="600">
          <div className="stat-icon-wrapper">
            <img src={`${url}images/concord/section-2/icon-cost.png`} alt="" className="stat-icon" />
          </div>
          <div className="stat-value gradient-text overflow-hidden">$20</div>
          <p className="stat-desc">Per Document: The Hidden Cost of Manual Management</p>
        </div>

        <div className="stat-card overflow-hidden" data-aos="zoom-in" data-aos-delay="600">
          <div className="stat-icon-wrapper">
            <img src={`${url}images/concord/section-2/icon-search.png`} alt="" className="stat-icon" />
          </div>
          <div className="stat-value gradient-text overflow-hidden" >40-60%</div>
          <p className="stat-desc">of Small Businesses Never Recover After Document Loss</p>
        </div>

        <div className="stat-card overflow-hidden" data-aos="fade-left" data-aos-delay="600">
          <div className="stat-icon-wrapper overflow-hidden">
            <img src={`${url}images/concord/section-2/icon-warning.png`} alt="" className="stat-icon" />
          </div>
          <div className="stat-value gradient-text overflow-hidden">47%</div>
          <p className="stat-desc">of Your Workforce Can't Find What They Need to Do Their Jobs</p>
        </div>

      </div>
    </div>
  </section>
  );
};

export default Section2;
